import { Box, Card, Stack, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { pageReload } from '../../redux/studentSlice';
import ProfileTab from './ProfileTab';

const CenteredBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ mt: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function Details() {
    const [value, setValue] = React.useState(0);

    const dispatch = useDispatch();
    const accType = localStorage.getItem("accType");

    const handleChange = (event, newValue) => {
        setValue(newValue);
        dispatch(pageReload())
    };

    return (
        <Card sx={{ height: "100%" }}>
            <Stack width={"100%"} height={"100%"}
                p={3}>
                <CenteredBox sx={{ width: '100%' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        textColor="secondary"
                        aria-label="secondary tabs example"
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        sx={{
                            backgroundColor: 'transparent',
                            '& .MuiTab-root': {
                                transition: 'color 250ms',
                                color: (theme) => theme.palette.text.secondary,
                            },
                            '& .Mui-selected': {
                                color: (theme) => theme.palette.primary.main,
                            },
                            '& .MuiTab-textColorSecondary.Mui-selected': {
                                backgroundColor: (theme) => theme.palette.primary.main,
                                borderRadius: "5px",
                                color: (theme) => theme.palette.common.white,
                            },

                            '& .MuiTab-textColorSecondary:focus': {
                                color: (theme) => theme.palette.common.white,
                            },
                        }}
                    >
                        <Tab value={0} label="Profile" />
                    </Tabs>
                </CenteredBox>

                <TabPanel value={value} index={0}>
                    <ProfileTab />
                </TabPanel>

            </Stack>
        </Card>
    )
}

export default Details